<!----复杂筛选框组件----->
<template>
  <div class="complexSelect">
    <el-popover placement="right" v-model="visible" trigger="click">
      <div class="flex">
        <el-input class="flex1" :disabled="disabled" v-model="text1" ref="elinput" :placeholder="value ? value : placeholder"
          @keyup.enter.native="enterFun" @clear="clear" :clearable="clearable" @size-change="onPageSizeChange"></el-input>
      </div>
      <el-table ref="table" :empty-text="empty" :data="data" @current-change="selectRow" :height="height" v-if="tableType">
        <template v-for="(i, key) in tbHead">
          <el-table-column :key="key" :min-width="i.Width" :prop="i.Value" show-overflow-tooltip>
            <template slot="header" slot-scope="/* eslint-disable vue/no-unused-vars */ scope">
              <span v-if="!i.Custom">{{ i.Name }}</span>
              <el-input v-else v-model="search" @input="onSearch(i.Value)" :placeholder="i.Name" />
            </template>
          </el-table-column>
        </template>
      </el-table>
      <page-module v-if="pageType" :listTotal="total" :page-size="pageParams.pageSize" @currentPage="currentPage"
        :pageIndex="pageParams.pageIndex" />
      <template slot="reference">
        <el-input :disabled="disabled" v-model="text" readonly></el-input>
      </template>
    </el-popover>
  </div>
</template>
<script>
import pageModule from "./page";
export default {
  components: {
    pageModule,
  },
  props: {
    pageType: {
      type: Boolean,
      default: false,
    },
    pageIndex: {
      type: Number,
      default: 1,
    },
    listTotal: {
      type: Number,
      default: undefined,
    },
    value: {},
    //表格最大高度
    height: {
      type: String,
      default: "300",
    },
    //表头
    tbHead: {
      type: Array,
      default: () => [],
    },
    //表数据
    tbData: {
      type: Array,
      default: () => [],
    },
    //用于搜索的字段
    keyStr: {
      type: String,
      default: "Name",
    },
    //查询不到的数据是否可以创建
    create: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    empty: {
      type: String,
      default: "暂无数据",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    pageSize: {
      type: Number,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      tableType: Math.random(),
      ClassId: null,
      total: 0,
      data: [],
      text: "", //输入框的值
      text1: "",
      time: null, //搜索延迟
      visible: false, //是否显示
      search: "", //搜索关键字
      pageParams: {
        pageSize: this.pageSize || 10, //分页大小
        pageIndex: this.pageIndex,
      },
    };
  },
  mounted() {
    this.text = this.value;
  },
  computed: {},
  watch: {
    pageIndex() {
      this.pageParams.pageIndex = this.pageIndex;
    },
    listTotal() {
      this.total = this.listTotal;
    },
    tbData() {
      this.tableType = Math.random();
    },
    visible(val) {
      // console.log('visible', val)
      if (val) {
        this.text1 = "";
        this.data = this.tbData;
        this.$nextTick(() => {

          this.$refs.elinput.focus();
        })
      } else {
        this.search = "";
        this.ClassId = null;
      }
      if (!this.create) {
        // if (!val)
      } else {
        this.$emit("input", this.text1);
        if (!val && !this.data.some((x) => x[this.keyStr] == this.text1)) {
          this.$emit("create");
        }
      }
    },
    value(val) {
      this.text = this.value;
    },
    tbData(val) {
      this.data = this.tbData;
    },
    text1(val) {
      if (this.pageType) {
        // console.log('触发 inputText', val)
        this.$emit("inputText", this.text1);

      } else if (this.visible) {
        this.data = this.tbData;

        this.data = this.data.filter(
          (x) => x[this.keyStr].indexOf(this.text1) != -1
        );
      }
    },
  },
  methods: {
    nodeSelect(val) {
      // console.log('val----', val)
      this.ClassId = val;
      this.$emit("changeSelect", val);
    },
    currentPage(val) {
      // console.log('触发 currentPage', val)
      this.$emit("currentPage", { val, text1: this.text1 });
    },
    // focus(){
    //   this.$refs.input.focus()
    // },
    onPageSizeChange() { },
    enterFun() {
      if (this.data.length > 0) {
        this.$emit("input", this.data[0][this.keyStr]);
        this.$emit("select", this.data[0]);
        this.visible = false;
      }
    },
    onSearch(key) {
      // console.log('key', key)
      // console.log('this.search', this.search)

      if (this.search) {
        this.data = this.data.filter((x) => x[key].indexOf(this.search) != -1);
      } else {
        this.data = this.tbData;
      }
    },
    selectRow(val) {
      if (val) {
        // console.log('val', val)
        // console.log('val[this.keyStr]', val[this.keyStr])
        this.text = this.value;
        this.$emit("input", val[this.keyStr]);
        this.$emit("select", val);
        this.visible = false;
      }
    },
    select() {

    },
    clear() {
      this.$emit("input", null);
      this.$emit("clear");
      this.$refs.table.setCurrentRow(null);
    },
  },
};
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
}

.flex1 {
  flex: 1;
}

.w60 {
  width: 120px;
}
</style>